<h2 mat-dialog-title>{{ data.title || 'Xác nhận' }}</h2>
    <mat-dialog-content>
      <p>{{ data.message }}</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()">  {{ data.cancelText || 'Hủy' }}</button>
      <button mat-raised-button color="warn" (click)="onConfirm()">  {{ data.confirmText || 'Xác nhận' }}</button>
    </mat-dialog-actions>
